import { Component, HostListener, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HelperService } from "../../helper.service";
import { Router } from "@angular/router";
import { NavBarComponent } from "../../nav-bar/nav-bar.component";
import { BaseService } from "../../services/base.service";
import { FormControl, FormGroup } from "@angular/forms";
import { catchError, throwError } from 'rxjs';
import { PinManagerService } from '../../services/pin-manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { NewPin } from '../../models/NewPin ';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import dayjs from "dayjs";
import { PinType } from 'src/app/models/pinType';
import { NewDeletePinComponent } from 'src/app/dialogs/pin-rework-dialogs/new-delete-pin/new-delete-pin.component';
import { TenantService } from 'src/app/services/tenant.service';
import {PIN_ICONS} from "../../dialogs/pin-rework-dialogs/new-save-pin/new-save-pin.component";
import { PinExportFilterComponent } from 'src/app/dialogs/pin-rework-dialogs/pin-export-filter/pin-export-filter.component';
import { SampleService } from '../../services/sample.service';
import { PinManagerComponent } from '../pin-manager/pin-manager.component';



@Component({
    selector: 'app-all-pins',
    templateUrl: './all-pins.component.html',
    styleUrls: ['./all-pins.component.css'],
    standalone: false
})
export class AllPinsComponent extends BaseService implements OnInit {


  allPinsForm: FormGroup;
  pinIcons = PIN_ICONS;

  // public tenantId: number;
  // public userId: number;

  @ViewChild('exportDropdown') exportDropdown: any;

  currentPage: number = 0;
  pageSize: number = 25;
  totalElements: number = 0;
  excludedId:number = 9; //N tester pin Id
  
  pinType: PinType;
  pintypeId: string = '0';
  tenantId: string = null;

  selectedPin: number = 0;

  protected readonly dayjs = dayjs;

  dateStringFormatting = 'YYYY-MM-DD';

  filterFromDate: string = '';
  filterToDate : string = '';

  placeholder: string = "-";
  fromDate: string;
  toDate: string;
  searchValue: string = null;
  tableHeight: string = '';

  displayedColumns: string[] = [
      'table-checkboxes',
      'table-farm',
      'table-field',
      'table-pinType',
      'table-description',
      'table-dateCreated',
      'table-createdBy',
      'table-actions'];
  pinTypesList: PinType[];
  selectedToDelete = [];

  dataSource = new MatTableDataSource<NewPin>([]);
  currentPin = null;
  selectedPinId: number = null;

  isNtesterPin: boolean = false;
  showToolTip: boolean = false;
  isPinItemSelected: boolean = false;
  isBulkDelete: boolean = false;
  isFilterBtnVisible: boolean = false;
  panelOpenState: boolean = false;
  hideButtonOptions: boolean = true;
  showExportMenu: boolean = false;
  showPinTypeMenu: boolean = false;
  showPageSizeMenu: boolean = false;

  constructor(
    public helper: HelperService,
    private router: Router,
    public nav: NavBarComponent,
    private pinManagerService: PinManagerService,
    public dialog: MatDialog,
    public deletePinDialog: MatDialog,
    private tenantService: TenantService,
    public exportPinsFilterDialog: MatDialog,
    private sampleService: SampleService,
    private pinManager: PinManagerComponent,
    private snackBar: MatSnackBar,
  ) {
    super();

    this.allPinsForm = new FormGroup({
      pinType: new FormControl(null)
    });
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.tableHeight = (window.innerHeight - 320) + 'px';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    this.showPinTypeMenu = false;
    this.showExportMenu = false;
    this.showPageSizeMenu = false;
  }


  isNoItemsFound: boolean = false;


  ngOnInit() {

    //REFRESH & POPULATE LIST ON TENANT CHANGE/UPDATE
    this.tenantService.currenttenantId.subscribe(tenantId => {
      if (tenantId) {
        this.populatePinList();
      }
    });

    // Refresh when pin-manager triggers (delete/convert/update)
    this.pinManager.refreshPins$.subscribe((message) => {
      this.populatePinList();
      if (message) {
        setTimeout(() => {
          this.snackBar.open(message, 'close', { duration: 3000 });
        }, 1500);
      }
    });


    this.populatePinTypesListDropDown();
    this.pinType = this.allPinsForm.controls.pinType.value;
    setTimeout(() => {
      this.setSelectedPinType(this.pinType);
    }, 800);


    const defaultfromDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
    const defaultToDate = dayjs().format('YYYY-MM-DD');

    this.filterFromDate = defaultfromDate;
    this.filterToDate = defaultToDate;

    this.fromDate = dayjs(this.filterFromDate).format('YYYY-MM-DD');
    this.toDate = dayjs(this.filterToDate).format('YYYY-MM-DD');

    setTimeout(() => {
      this.populatePinList();
    }, 500)

  }

  populatePinTypesListDropDown() {
    this.pinManagerService.getPinTypesList().pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    )
      .subscribe((response) => {
        this.pinTypesList = response;

        this.pinType = {
          id: null,
          name: 'All',
          dateModified: ' '
        }

        this.pinTypesList.unshift(this.pinType);
        this.allPinsForm.controls.pinType.setValue(this.pinType);

        
        if (document?.title === 'SGS Precision Gateway') {
          this.pinTypesList = this.pinTypesList.filter(item => item.id !== this.excludedId);
        }

        this.nav.toggleLoading(false);
      });
  }

  setSelectedPinType(pinType: PinType) {
    this.clearSelectedPins();
    if (this.pinType) {
      this.pinType = this.allPinsForm.controls.pinType.value;
      this.allPinsForm.controls.pinType.setValue(pinType);
      this.populatePinList();
    } else {
      this.populatePinList();
    }
  }

  selectPinType(pt: PinType) {
    this.showPinTypeMenu = false;
    this.pinType = pt;
    this.allPinsForm.controls.pinType.setValue(pt);
    this.clearSelectedPins();
    this.populatePinList();
  }


  populatePinList() {
    this.nav.toggleLoading(true);

    let tenantId = Number(sessionStorage.getItem("selectedTenant"));

    this.pinManagerService.getAllPaginatedPinsListByTenantId(
      tenantId,
      this.currentPage,
      this.pageSize,
      this.searchValue,
      this.fromDate,
      this.toDate,
      this.pinType?.id ? this.pinType.id : null
    ).pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      setTimeout(() => {

        this.dataSource.data = response.content;
        this.isNoItemsFound = response?.content.length <= 0;
      }, 300)

      // this.dataSource = new MatTableDataSource<NewPin>(result.content);
     this.hideShowFilterReset();
      setTimeout(() => {
        this.nav.toggleLoading(false);
      }, 1400)
      this.totalElements = response.totalElements;
    });

  }

  searchPins(searchValue: string) {
    this.searchValue = searchValue.trim().toLocaleLowerCase();
    setTimeout(() => {
      this.clearSelectedPins();
      this.populatePinList();
    }, 1400)
  }

  clearSelectedPins() {
    for (let id of this.selectedToDelete) {
      this.onPinSelectedChecked(false, id);
    }
    this.isPinItemSelected = false;
    this.selectedToDelete = [];
  }

  hideShowFilterReset(){
    const defaultfromDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
    const defaultToDate = dayjs().format('YYYY-MM-DD');
    if(this.fromDate !== defaultfromDate || this.toDate !== defaultToDate || this.searchValue || this.pinType.name !== 'All'){
      this.isFilterBtnVisible = true;
    }else{
      this.isFilterBtnVisible = false;
    }
  }
  
  filterDateRange() {
    if(this.filterFromDate && this.filterToDate) {
      this.clearSelectedPins();
      this.fromDate = this.filterFromDate ? dayjs(this.filterFromDate).format('YYYY-MM-DD') : '';
      this.toDate = this.filterToDate ? dayjs(this.filterToDate).format('YYYY-MM-DD') : '';
      this.populatePinList();
    }
  }

  resetFilter() {
    this.refreshBrowser();
  }

  refreshBrowser() {
    // FORCE REFRESH BROWSER
    this.router.navigateByUrl("/pin-manager/sample-groups", { skipLocationChange: true }).then(() => {
      this.router.navigate(["/pin-manager/all-pins"]);
    });
  }


  goToPage(page: number) {
    this.clearSelectedPins();
    this.currentPage = page;
    this.populatePinList();
  }

  onPageSizeChange() {
    this.currentPage = 0;
    this.clearSelectedPins();
    this.populatePinList();
  }

  get lastPage(): number {
    return Math.max(0, Math.ceil(this.totalElements / this.pageSize) - 1);
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }


  toggleAllSelection(event: any): void {
    this.isPinItemSelected = event.target.checked;
    this.dataSource.data.forEach(item => {
      if(item?.pinType.id !== 9) {
        this.onPinSelectedChecked(event, item.id);
      }
    });
  }



  onPinSelectedChecked(event: any, id: number) {
    const checked = event?.target?.checked ?? event?.checked ?? false;
    if (checked) {
      if (!this.selectedToDelete.includes(id)) {
        this.selectedToDelete.push(id);
      }
    } else {
      const index = this.selectedToDelete.indexOf(id);
      if (index > -1) {
        this.selectedToDelete.splice(index, 1);
      }
    }
    if (this.selectedToDelete.length > 0) {
      this.pinManager.closeSidePanel();
      this.selectedPinId = null;
    }
  }



  openDeletePinDialog() {
    const selectedPins: any[] = this.dataSource.data.filter(p => this.selectedToDelete.includes(p.id));
    const description = selectedPins.length === 1 ? (selectedPins[0].description || 'Pin') : selectedPins.length + ' Pin(s)';
    const field = selectedPins.length === 1 ? (selectedPins[0].field?.name || '-') : 'multiple fields';

    const dialogRef = this.deletePinDialog.open(NewDeletePinComponent, {
      panelClass: 'compact-dialog',
      data: {
        isBulkDelete: true,
        description: description,
        field: field
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result.option == 'delete') {
        this.deletePin();
        this.isPinItemSelected = false;
        // this.allPinsForm.controls.isPinSelected.setValue(false);
      }
    });
  }


  deletePin() {
    this.nav.toggleLoading(true);

    this.selectedToDelete.forEach((pinId) => {
      if (pinId) {
        this.pinManagerService.deletePinById(pinId).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
        ).subscribe(() => {
          this.selectedToDelete = [];
          this.populatePinList();
          this.nav.toggleLoading(false);
        });
      }

    })
  }


  viewPin(pin) {
    this.selectedPinId = pin.id;
    if (pin.pinType.id === 4) {
      this.sampleService.getSoilSamplesListByPinId(pin.id).pipe(
        catchError(e => { console.error(e); return throwError(() => e); })
      ).subscribe(samples => {
        this.pinManager.openPinDetail(pin, samples.map(s => ({ id: s.id, name: s.name, groupName: s.group?.name, groupId: s.group?.id, dateCreated: s.creationDate, note: s.note, isCompleted: s.isCompleted, soil: s.soil })));
      });
    } else if (pin.pinType.id === 3) {
      this.sampleService.getSoftTissueSamplesListByPinId(pin.id).pipe(
        catchError(e => { console.error(e); return throwError(() => e); })
      ).subscribe(samples => {
        this.pinManager.openPinDetail(pin, samples.map(s => ({ id: s.id, name: s.name, groupName: s.group?.name, groupId: s.group?.id, dateCreated: s.creationDate, note: s.note, isCompleted: s.isCompleted, softTissue: s.softTissue })));
      });
    } else {
      this.pinManager.openPinDetail(pin);
    }
  }
  
  exportPinsAsExcel() {
    let tenantId = Number(sessionStorage.getItem("selectedTenant"));
    // let isCsvDownload: boolean = true;
        const dialogRef = this.exportPinsFilterDialog.open(PinExportFilterComponent, {
          panelClass: 'compact-dialog',
          data: {
            isCsvDownload: true
          }
        });

    dialogRef.afterClosed().subscribe(result => {
     if (tenantId && result?.isCsvDownload) {
      this.pinManagerService.postExportPinsAsExcel(tenantId, result?.farmId, result?.fieldId, result?.pinTypeId, result?.fromDate, result?.toDate).subscribe(response => {
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const filename = `pins_export_${timestamp}.xlsx`;
        const link = document.createElement('a');
        link.href = response.download_url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.nav.toggleLoading(false);
      });
    } 
   });
  }

  exportPinsToZipShpFile() {
    let tenantId = Number(sessionStorage.getItem("selectedTenant"))

      const dialogRef = this.exportPinsFilterDialog.open(PinExportFilterComponent, {
          panelClass: 'compact-dialog',
          data: {
            isShpFileDownload: true
          }
     });

  dialogRef.afterClosed().subscribe(result => {
    if (tenantId && result?.isShpFileDownload) {
      this.pinManagerService.postExportPinsToZipShpFile(tenantId, result?.farmId, result?.fieldId, result?.pinTypeId, result?.fromDate, result?.toDate).subscribe(response => {
        const link = document.createElement('a');
        link.href = response.download_url;
        link.download = 'pinsZipExport.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.nav.toggleLoading(false);
      });
      }
    })
  }


}


